
export const toast = {
  welcomeBack: 'Willkommen zurück!',
  loginFailed: 'Anmeldung fehlgeschlagen. Bitte überprüfe deine Zugangsdaten.',
  logoutSuccess: 'Du wurdest erfolgreich abgemeldet.',
  sessionExpired: 'Deine Sitzung ist abgelaufen. Bitte melde dich erneut an.',
  authenticationRequired: 'Authentifizierung erforderlich',
  loginRequired: 'Du musst eingeloggt sein',
  loginRequiredForPlan: 'Du musst eingeloggt sein, um einen Plan zu erstellen',

  accountCreatedSuccess: 'Konto erfolgreich erstellt! Prüfe deine E-Mail für den Bestätigungslink',
  registrationFailed: 'Registrierung fehlgeschlagen',

  otpVerificationSuccess: 'Gerät erfolgreich bestätigt. Willkommen!',
  otpCodeSent: 'Ein neuer Bestätigungscode wurde an deine E-Mail gesendet.',
  otpCodeSentFailed: 'Bestätigungscode konnte nicht gesendet werden. Bitte versuche es erneut.',
  newDeviceDetected: 'Neues Gerät erkannt. Bitte bestätige deine Identität.',

  passwordResetEmailSent: 'Wenn ein Konto mit dieser E-Mail existiert, erhältst du in Kürze Anweisungen zum Zurücksetzen.',
  passwordResetRequestFailed: 'Reset-E-Mail konnte nicht gesendet werden. Bitte versuche es erneut.',

  passwordResetSuccess: 'Passwort erfolgreich zurückgesetzt. Du kannst dich jetzt mit deinem neuen Passwort anmelden.',
  passwordResetFailed: 'Passwort konnte nicht zurückgesetzt werden. Bitte fordere einen neuen Reset-Link an.',

  passwordsDoNotMatch: 'Neue Passwörter stimmen nicht überein',
  passwordTooShort: 'Passwort muss mindestens 8 Zeichen lang sein',
  passwordChangeSuccess: 'Passwort erfolgreich geändert!',
  passwordChangeFailed: 'Passwort konnte nicht geändert werden',

  deviceAccessRevoked: 'Gerätezugriff widerrufen',
  deviceRevokeFailed: 'Gerät konnte nicht widerrufen werden',
  deviceRevokedSuccess: 'Gerätezugriff erfolgreich widerrufen.',
  deviceRevokedFailed: 'Gerätezugriff konnte nicht widerrufen werden. Bitte versuche es erneut.',
  devicesLoadFailed: 'Geräte konnten nicht geladen werden',

  twoFactorEnabled: '2FA aktiviert',
  twoFactorDisabled: '2FA deaktiviert',
  twoFactorToggleFailed: '2FA konnte nicht umgeschaltet werden',

  profileSetupComplete: 'Profil erfolgreich eingerichtet!',
  profileSaveFailed: 'Profil konnte nicht gespeichert werden',
  profileLoadFailed: 'Profil-Daten konnten nicht geladen werden',
  noChangesToSave: 'Keine Änderungen zum Speichern',
  profileUpdateSuccess: 'Profil erfolgreich aktualisiert!',
  profileUpdateFailed: 'Profil konnte nicht aktualisiert werden. Bitte versuche es erneut.',
  avatarUploadSuccess: 'Profilfoto aktualisiert.',
  avatarUploadFailed: 'Foto konnte nicht hochgeladen werden. Bitte versuche es erneut.',

  subscriptionCancelled: 'Abonnement gekündigt. Zugriff bis {{subscriptionEndDate}}',
  subscriptionCancelFailed: 'Abonnement konnte nicht gekündigt werden',
  paymentMethodUpdated: 'Zahlungsmethode aktualisiert',
  paymentMethodUpdateFailed: 'Zahlungsmethode konnte nicht aktualisiert werden',

  planGeneratedSuccess: 'Plan erfolgreich erstellt! 🎉',
  planGenerationFailed: 'Plan konnte nicht erstellt werden: {{errorMessage}}',
  planCreatedSuccess: 'Plan erfolgreich erstellt! 🎊',
  planCreateFailed: 'Plan konnte nicht erstellt werden',
  planUpdatedSuccess: 'Plan erfolgreich aktualisiert.',
  planUpdateFailed: 'Plan konnte nicht aktualisiert werden. Bitte versuche es erneut.',
  noPlanToDownload: 'Kein Plan zum Herunterladen verfügbar',
  noPlanData: 'Keine Plan-Daten verfügbar. Bitte erstelle zuerst einen Ernährungsplan.',
  noPlanPreview: 'Keine Plan-Vorschau gefunden. Bitte erstelle zuerst eine Vorschau.',
  mealCompletedSuccess: 'Mahlzeit als erledigt markiert.',
  mealUncompletedSuccess: 'Mahlzeit als nicht erledigt markiert.',

  mealSwapped: '{{mealType}} am Tag {{dayNumber}} zu {{newMealName}} getauscht ✨',
  mealsUpdatedForDay: 'Alle Mahlzeiten an Tag {{dayNumber}} aktualisiert ✨',
  dietTypeUpdated: 'Diät-Typ auf {{newDietType}} aktualisiert ✨',
  calorieTargetAdjusted: 'Kalorienziel auf {{newCalories}} kcal angepasst ✨',
  planModificationFailed: 'Plan konnte nicht geändert werden',

  pdfDownloadVipOnly: 'PDF-Download ist eine VIP-Funktion. Bitte upgraden, um darauf zuzugreifen.',
  generatingMealPlanPdf: 'Dein Ernährungsplan-PDF wird erstellt...',
  generatingDayPlanPdf: 'Täglicher Essensplan PDF wird erstellt...',
  pdfDownloadSuccess: 'PDF erfolgreich heruntergeladen!',
  pdfGenerationFailed: 'PDF konnte nicht erstellt werden. Bitte erneut versuchen.',

  recipeGenerationVipOnly: 'Rezept-Erstellung ist eine VIP-Funktion',
  recipeGeneratedSuccess: 'Rezept erfolgreich erstellt! 🎉',
  recipeGenerationFailed: 'Rezept konnte nicht erstellt werden: {{errorMessage}}',
  recipeAddedToFavorites: 'Rezept zu Favoriten hinzugefügt.',
  recipeRemovedFromFavorites: 'Rezept aus Favoriten entfernt.',
  recipeAddedToShoppingList: 'Zutaten zur Einkaufsliste hinzugefügt.',

  shoppingListUpdateFailed: 'Einkaufsliste konnte nicht aktualisiert werden',
  loadShoppingListFailed: 'Einkaufsliste konnte nicht geladen werden',
  clearShoppingListFailed: 'Einkaufsliste konnte nicht geleert werden',
  shoppingListCleared: 'Einkaufsliste geleert.',
  shoppingListExported: 'Einkaufsliste exportiert.',
  shoppingItemAdded: 'Artikel zur Einkaufsliste hinzugefügt.',
  shoppingItemDeleted: 'Artikel aus der Einkaufsliste entfernt.',
  ingredientAddedToShoppingList: '{{food}} zur Einkaufsliste hinzugefügt',
  ingredientQuantityUpdated: 'Menge von {{food}} aktualisiert',
  ingredientAddFailed: 'Zutat konnte nicht hinzugefügt werden',
  ingredientsAddFailed: 'Zutaten konnten nicht hinzugefügt werden',
  addIngredientsFailed: 'Zutaten konnten nicht hinzugefügt werden',
  addItemFailed: 'Element konnte nicht hinzugefügt werden',
  updateItemFailed: 'Element konnte nicht aktualisiert werden',
  removeItemFailed: 'Element konnte nicht entfernt werden',
  removeItemsFailed: 'Elemente konnten nicht entfernt werden',

  weightLogged: 'Gewicht protokolliert!',
  weightLogFailed: 'Gewicht konnte nicht protokolliert werden',
  weightEntryAdded: 'Gewichtseintrag hinzugefügt!',
  weightEntryUpdated: 'Gewichtseintrag aktualisiert!',
  weightEntrySaveFailed: 'Gewichtseintrag konnte nicht gespeichert werden',
  weightEntryDeleted: 'Gewichtseintrag gelöscht',
  entryDeleteFailed: 'Eintrag konnte nicht gelöscht werden',
  weightAddedSuccess: 'Gewichtseintrag gespeichert.',
  weightUpdatedSuccess: 'Gewichtseintrag aktualisiert.',
  weightDeletedSuccess: 'Gewichtseintrag gelöscht.',
  weightAddFailed: 'Gewicht konnte nicht gespeichert werden. Bitte versuche es erneut.',

  photoUploadSuccess: 'Foto hochgeladen!',
  photoUploadFailed: 'Foto konnte nicht hochgeladen werden',
  photoDeleteFailed: 'Foto konnte nicht gelöscht werden',

  achievementUnlocked: '🎉 Erfolg freigeschaltet: {{title}}',

  productSettingsLoadFailed: 'Produkteinstellungen konnten nicht geladen werden',
  affiliateEnabledVipOnly: 'Affiliate-System aktiviert – VIP-Benutzer können jetzt den Smart-Shopping-Modus nutzen',
  affiliateDisabledSimpleList: 'Affiliate-System deaktiviert – Alle Benutzer wurden in den Einfach-Liste-Modus gewechselt',

  sendMessageFailed: 'Nachricht konnte nicht gesendet werden',

  savedSuccess: 'Änderungen erfolgreich gespeichert.',
  saveFailed: 'Änderungen konnten nicht gespeichert werden. Bitte versuche es erneut.',
  updateFailed: 'Aktualisierung fehlgeschlagen',
  copiedToClipboard: 'In die Zwischenablage kopiert.',
  networkError: 'Netzwerkfehler. Bitte überprüfe deine Verbindung.',
  unknownError: 'Ein unerwarteter Fehler ist aufgetreten. Bitte versuche es erneut.',
};